import { Component, OnInit } from '@angular/core';
import { text } from 'src/services/text.service';
import { Model } from 'src/logic/model';
import { OperationParam } from 'src/logic/enum/operation-param';
import { Act } from 'src/logic/act';
import { Actions } from '../../logic/enum/actions';
import { SnippetsGroupsItem, SnippetsGroupsParam } from 'src/logic/types/snippets-groups-item';
import { ItemStates } from 'src/logic/enum/item-states';
import { Constants } from 'src/logic/constants';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.less'],
    standalone: false
})
export class SettingsComponent implements OnInit {

  constructor(public model: Model,  public act: Act) { }

  ItemStates = ItemStates;
  Constants = Constants;
  text = text;
  snippetsGroupsNewName: string = "";
  snippetsGroupsEditItem: SnippetsGroupsItem  = new SnippetsGroupsItem();

  ngOnInit(): void {

  }

  settingsBlockSaveClick(){
    this.act.do(Actions.codeSectionConfigSave);
  }

  settingsBlockResetClick(){
    this.model.patternsArrayTextareaVal.set(Constants.patternsArrayTextDefault);
  }

  snippetsGroupsCreateClick(){
    if(this.snippetsGroupsNewName.length>0){
      this.act.do(Actions.snippetsGroups, { operation: OperationParam.Add, id: 0, txtValue: this.snippetsGroupsNewName });
    }
  }

  snippetsGroupsEditClick(g: SnippetsGroupsItem){
    let obj: any = {};
    Object.assign(obj, g);
    this.snippetsGroupsEditItem = obj;
    this.model.snippetsGroups.forEach((g)=>{g.state=ItemStates.None});
    g.state=ItemStates.Edit;
  }

  snippetsGroupsSaveClick(g: SnippetsGroupsItem){
    let obj: SnippetsGroupsParam = new SnippetsGroupsParam();
    Object.assign(obj, this.snippetsGroupsEditItem);
    obj.operation = OperationParam.Update;
    this.act.do(Actions.snippetsGroups, obj);
    g.state=ItemStates.None;
  }

  snippetsGroupsCancelClick(g: SnippetsGroupsItem){
    g.state=ItemStates.None;
  }

  snippetsGroupsDelete(g: SnippetsGroupsItem){
    this.act.do(Actions.snippetsGroups, { operation: OperationParam.Del, id: g.id });
  }
}
